@if (patientReferralMatchVerifications.length > 0) {
  <table class="table table-sm table-bordered mb-1">
    <thead class="table-dark">
      <tr>
        <th>Date Found</th>
        <th>Evidence Type</th>
        <th>Referral Date</th>
        <th>Prescriber</th>
        <th>Referral Specialty</th>
        <th>Found By</th>
        <th>Note To Client</th>
      </tr>
    </thead>
    <tbody>
      @for (rmv of patientReferralMatchVerifications; track rmv; let i = $index) {
        <tr>
          <td>
            <div class="d-flex">
              <div class="selection me-1">
                <fa-icon [icon]="['fas', 'check-circle']" size="1x" class="check" />
              </div>
              <div>
                {{ rmv.ehrReferralVerification.createdAt | date: 'MM/dd/yyyy' }}
              </div>
            </div>
          </td>
          <td>
            {{ rmv.ehrReferralVerification.reasons | referralVerificationReasonShortNames | joinList }}
          </td>
          <td>
            {{ rmv.ehrReferralVerification.referralDate | date: 'MM/dd/yyyy' }}
          </td>
          <td>
            <div>{{ rmv.ehrReferralVerification.provider?.fullName | blankValueDash }}</div>
            @if (rmv.ehrReferralVerification.provider) {
              <div>
                NPI: {{ rmv.ehrReferralVerification.provider.npi | blankValueDash }}
              </div>
            }
          </td>
          <td>
            {{ rmv.ehrReferralVerification.referralSpecialty | blankValueDash }}
          </td>
          <td>
            {{ rmv.ehrReferralVerification.user?.fullName | blankValueDash }}
          </td>
          <td class="phi">
            {{ rmv.ehrReferralVerification.notes | blankValueDash }}
          </td>
        </tr>
      }
    </tbody>
  </table>
}
